<header class="ds-header">
  <ng-content></ng-content>
</header>
